export default __webpack_public_path__ + "static/media/hipchat.8f24c7b3.svg";